var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtomsIconFilledCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.27 17.294V18.8c0 .573-.467 1.07-1.055 1.07a1.088 1.088 0 0 1-1.086-1.07v-1.489c-.99-.136-1.81-.466-2.488-.94a.996.996 0 0 1-.452-.83c0-.557.452-1.01.995-1.01.211 0 .407.06.573.181.694.482 1.523.8 2.533.8 1.177 0 1.75-.558 1.75-1.132 0-.754-.875-1.01-2.036-1.281-1.644-.378-3.755-.83-3.755-3.077 0-1.415 1.038-2.6 2.88-2.934V5.6c0-.589.483-1.07 1.086-1.07.588 0 1.056.481 1.056 1.07v1.477a6.01 6.01 0 0 1 2.066.744.97.97 0 0 1 .497.844 1 1 0 0 1-.98.995.933.933 0 0 1-.513-.15c-.769-.437-1.568-.649-2.276-.649-1.117 0-1.63.423-1.63 1.025 0 .679.845.89 2.006 1.162 1.659.376 3.77.874 3.77 3.106 0 1.574-.963 2.813-2.94 3.14M12.2 2.4c-5.412 0-9.8 4.388-9.8 9.8 0 5.412 4.388 9.8 9.8 9.8 5.412 0 9.8-4.388 9.8-9.8 0-5.412-4.388-9.8-9.8-9.8",
    fill: "#FF6600",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomsIconFilledCoin);
export default __webpack_public_path__ + "static/media/atoms-icon-filled-coin.7bfeced66ff82f0ccf9f254f8f99992f.svg";
export { ForwardRef as ReactComponent };